import { ScreenServiceApi } from 'mnvm-mypage-app-ts-if'
import { config } from './api-config'
import {
  type V1GetByTypeResponse,
  type ScreenServiceGetByTypeRequest
} from 'mnvm-mypage-app-ts-if'
import { handleQueryError } from '@/utils/error'

export const screenServiceApi = new ScreenServiceApi(config)

export const getScreensByType = async (
  request: ScreenServiceGetByTypeRequest
): Promise<V1GetByTypeResponse | undefined> => {
  try {
    return await screenServiceApi.screenServiceGetByType(request)
  } catch (err) {
    handleQueryError(err).catch((error) => {
      console.error('Failed to handle error:', error)
    })
  }
}
